import { render } from "./CustomerCreateTicket.vue?vue&type=template&id=79cf3d4e&scoped=true"
import script from "./CustomerCreateTicket.vue?vue&type=script&lang=js"
export * from "./CustomerCreateTicket.vue?vue&type=script&lang=js"

import "./CustomerCreateTicket.vue?vue&type=style&index=0&id=79cf3d4e&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\bocw_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cf3d4e"]])

export default __exports__